import { useRef } from 'react';
/**
 * Determines if the given value has changed.
 * @param {any} value The value to compare against.
 * @param {function} isEqual The checking mechanism. Defaults to shallow equal.
 * @return {boolean} Whether if the value has changed.
 */
export function useChanged(value, isEqual = (a, b) => a === b) {
    const prevValueRef = useRef();
    if (prevValueRef.current == null) {
        prevValueRef.current = { value };
        return false;
    }
    const prevValue = prevValueRef.current.value;
    const changed = !isEqual(prevValue, value);
    prevValueRef.current.value = value;
    return changed;
}
//# sourceMappingURL=useChanged.js.map